import { Box, Divider, Stack } from '@mui/material';
import { Fragment } from 'react';
import ArticleCard from '../ArticleCard/ArticleCard';
import { articleCardLocation } from '../../utilities/gtm';
import BrandHeading from '../Page/BrandHeading';
import { useTranslation } from 'react-i18next';
import { ArticleCardVariant } from '../ArticleCard/CardUtils';
import { useArticles } from '../../hooks/useArticles';

interface EditorialRecommendationsProps {
  readonly category?: string;
  readonly contentType?: string[] | string;
  readonly variant?: ArticleCardVariant;
}

export default function EditorialRecommendations({
  category,
  contentType,
  variant = 'default',
}: EditorialRecommendationsProps) {
  const { t } = useTranslation();
  const { articles } = useArticles({
    category,
    contentType,
    limit: 6,
    orderBy: 'featureDocument',
  });

  return (
    <>
      {articles.length > 0 && (
        <BrandHeading
          component='h2'
          variant='subtitle2'
          sx={{ marginBottom: 1 }}
        >
          {t('frontPage.staffPicks')}
        </BrandHeading>
      )}
      <Stack spacing={1}>
        {articles.map((article, index) => {
          return (
            <Fragment key={'editorial-recommendations-' + article.id}>
              <ArticleCard
                variant={variant}
                meta={article}
                heading='h3'
                gtmData={{ index, location: articleCardLocation.STAFF_PICKS }}
              />
              {articles.length > index + 1 &&
                variant === 'minimizedHighlight' && (
                  <Box
                    sx={{
                      paddingY: 1,
                    }}
                  >
                    <Divider />
                  </Box>
                )}
            </Fragment>
          );
        })}
      </Stack>
    </>
  );
}
